import { LuTarget } from 'react-icons/lu';
import type { OrigemMarketing } from '../services/OpportunityService';

/**
 * De onde a pessoa veio, em uma linha — a mesma regra na ficha do negócio e no filtro da Pipeline,
 * para o que a tela mostra e o que o filtro agrupa nunca divergirem.
 *
 * A porta de entrada (RD Station, webhook, página de captura) manda a origem de três jeitos, e eles
 * se completam: o rótulo pronto da plataforma ("Busca Paga | google"), os `utm_*` do link e o nome
 * da conversão (o formulário ou o botão em que a pessoa clicou). A ordem abaixo é da informação
 * mais legível para a mais crua.
 *
 * Nulo quando não há nada: aí quem chama decide o que dizer (disparo, anúncio ou "Entrada orgânica").
 */
export function textoOrigemMarketing(origem?: OrigemMarketing | null): string | null {
    if (!origem) return null;

    const limpo = (v?: string | null) => (v ?? '').trim() || null;

    // 1. O rótulo que a plataforma já entrega pronto.
    const rotulo = limpo(origem.origem);
    if (rotulo) return rotulo;

    // 2. Sem rótulo, o par source/medium é o que o marketing reconhece.
    const source = limpo(origem.utmSource);
    const medium = limpo(origem.utmMedium);
    if (source) return medium ? `${source} · ${medium}` : source;

    // 3. Por último, a porta: diz menos de onde veio, mas é melhor que "orgânica", que seria mentira.
    return limpo(origem.conversao);
}

/** O detalhe que cabe depois do rótulo: a campanha do anúncio, quando o link trouxe. */
export function campanhaOrigemMarketing(origem?: OrigemMarketing | null): string | null {
    return (origem?.utmCampaign ?? '').trim() || null;
}

/**
 * A origem pronta para a ficha. Fora do `textoOrigemMarketing` porque aqui entra ícone e marcação;
 * quem só precisa do texto (filtro, agrupamento, exportação) usa a função de cima.
 */
export function rotuloOrigemMarketing(origem?: OrigemMarketing | null) {
    const texto = textoOrigemMarketing(origem);
    if (!texto) return null;

    const campanha = campanhaOrigemMarketing(origem);
    return (
        <span className="pl-etapa" title={campanha ? `Campanha: ${campanha}` : undefined}>
            <LuTarget size={13} />
            <span>{texto}{campanha && <span className="dd-origem-campanha"> · {campanha}</span>}</span>
        </span>
    );
}
